<ng-container *ngIf="isLoading then showLoading else mainScreen"></ng-container>


<ng-template #showLoading>
    <div *ngIf="isLoading" fxLayout="column" style="width: 94vw;" fxLayoutGap="10px">
        <app-skeleton-loading></app-skeleton-loading>
        <app-skeleton-loading></app-skeleton-loading>
        <app-skeleton-loading></app-skeleton-loading>
    </div>
</ng-template>

<ng-template #mainScreen>
    <ng-container
            *ngIf="!isLoading && displayConsents.length > 0 then ShowMessages else ShowNoMessagesMessage"></ng-container>
</ng-template>


<ng-template #ShowMessages>
    <cdk-virtual-scroll-viewport itemSize="50" [style.height.px]="listHeight" style=" width: 94vw;">
        <div *cdkVirtualFor="let item of displayConsents"
             style="margin-top: 0.5rem; width: 94vw; margin-bottom: 0.5rem;display: flex; flex-direction: row;" (click)="showCustomForm(item)">
            <div fxLayout="column" fxLayoutGap="10px">

                <div fxLayout="row" class="mobile-list-item-title" style="font-size: 16px; font-weight: 600;" [style.color] = "!isNavigationToFormDisabled(item) ? '#0082e6' : 'lightgray'">{{item.formTitle}}</div>
                <div fxLayout="row" style="font-size: 12px;">Ονοματεπώνυμο Παιδιού: {{item.displayName}}</div>
                <div fxLayout="row" style="font-size: 12px;">Ημ. Συμπλήρωσης: {{item.consentDate}}</div>
                <div fxLayout="row" style="font-size: 12px;">Συμπληρώθηκε από: {{item.modified_by}}</div>

                <div style="height: 1px; width: 94vw; background-color: var(--secondaryBlue)"></div>
            </div>
        </div>
    </cdk-virtual-scroll-viewport>
</ng-template>
<ng-template #ShowNoMessagesMessage>
    <div fxLayout="column" style="width: 94vw;" [style.height.px]="listHeight" fxLayoutAlign="center center center">
        <label style="font-size: 18px; font-weight: 650">Δεν υπάρχουν δηλώσεις για εσάς</label>
    </div>
</ng-template>
